import { Injectable } from '@angular/core'
import { MbMyAddressesAdapter } from '../../shared/adapters/mb-my-addresses.adapter'
import { MbMyAddressesConnector } from '../../shared/connectors/mb-my-addresses-connector'

@Injectable({
  providedIn: 'root',
})
export class MbMyaccountAddressbookConnector extends MbMyAddressesConnector {

  constructor (protected adapter: MbMyAddressesAdapter) {
    super()
  }

  getAllAddresses () {
    return this.get('addressBookAddresses')
  }

  getShippingAddresses () {
    return this.get('myShippingAddresses')
  }

  getBillingAddresses () {
    return this.get('checkoutBillingAddresses')
  }

  protected get (endpoint: string) {
    return this.adapter.load(endpoint)
  }
}
